import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import BookingListPage from "./BookingListPage";

const BookingList = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb */}
      <Breadcrumb title="Booking List" />

      {/* TableDataLayer */}
      {/* <AllCounselorTableLayer url={"counselors"} /> */}
      <BookingListPage />
    </MasterLayout>
  );
};

export default BookingList;
